export default __webpack_public_path__ + "static/media/products-zero.33298a80.svg";